module.exports = __webpack_public_path__ + "img/jiaohua.1bf85673.jpg";